module.exports = __webpack_public_path__ + "static/media/nemanja.40442545.jpg";